export const DASHA_CYCLE_LABELS: Record<string, { label: string; cycle: string; duration: string }> = {
  en: { label: 'Dasha cycle', cycle: 'Cycle {{number}}', duration: '120 years per cycle' },
  hi: { label: 'दशा चक्र', cycle: 'चक्र {{number}}', duration: 'हर चक्र में 120 वर्ष' },
};
